import config from '../../../config';

const baseUrl = `${config.apiUrl()}/BackOffice/FamilyMembers`;

export default {
  addFamilyMemberUrl: (): string => `${baseUrl}`,
  deleteFamilyMember: (familyMemberId): string => `${baseUrl}/${familyMemberId}`,
  editFamilyMemberUrl: (familyMemberId): string => `${baseUrl}/${familyMemberId}`,
};
